var PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    YepNopeMessage        = require("app/ui/YepNopeMessage"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    kind                  = require("enyo/kind"),
    themeVars             = require("app/theme/variables.js");

require("./YepNopeMessagePopup.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");
require("app/theme/IconButton--positive.less");
require("app/theme/IconButton--negative.less");

module.exports = kind(/** @lends  app.AppLayout.YepNopeMessagePopup.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.YepNopeMessagePopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-app-layout-yep-nope-message-popup",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * @private
     */
    components: [{
        name:    "message",
        kind:    YepNopeMessage,
        classes: "app-app-layout-yep-nope-message-popup__message"
    }],

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("theme", "positive");
            this.$.message.$.nopeButton.set("theme", "negative");
        };
    })

});
